module.exports = __webpack_public_path__ + "img/kenko-keiei.ddf2415b.jpeg";